"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const programs = [{
  id: 1,
  title: "Beginner Program",
  description: "Foundation‑level classical ballet training for students new to dance. Learn proper technique, basic positions, and develop musicality in a supportive environment.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508208/img/beginner_ballet_student_practicing.png",
  delay: 0
}, {
  id: 2,
  title: "Intermediate Program",
  description: "Structured curriculum advancing technical precision, artistry, and performance skills. Students refine their craft through demanding exercises and repertoire study.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508208/img/intermediate_ballet_dancers_rehearsing.png",
  delay: 100
}, {
  id: 3,
  title: "Advanced Program",
  description: "International‑level training for serious dancers pursuing professional careers. Intensive instruction in classical technique, variations, and partnering work.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508208/img/advanced_ballet_performance_preparation.png",
  delay: 200
}];
export default function OurPrograms() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="our-programs" ref={sectionRef} className="py-20 px-6 md:px-12 lg:px-16 bg-background">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground text-center mb-16">
          Our Programs
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program, i) => <Card key={program.id} data-index={i} className={`
                group overflow-hidden transition-all duration-300 ease-out-back
                ${sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}
              `} style={{
          transitionDelay: sectionVisible ? `${program.delay}ms` : '0ms'
        }}>
              <img src={program.image} alt={program.title} className="w-full h-56 object-cover" />
              
              <CardHeader>
                <CardTitle className="text-2xl text-foreground">
                  {program.title}
                </CardTitle>
                <CardDescription className="text-base leading-relaxed">
                  {program.description}
                </CardDescription>
              </CardHeader>

              <CardContent>
                <Button asChild className="w-full group-hover:scale-102 transition-transform duration-120 ease-in-out">
                  <Link to="#">Learn More</Link>
                </Button>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}